import { firebase } from '../config/configureFirebase';
import { onValue, push, update, remove, get } from 'firebase/database';

const CAMPAIGN_CONFIG_FIELDS = ['name', 'audience', 'amount', 'active', 'startAt', 'endAt', 'maxGrants'];

const pickConfig = (campaign) => {
  const out = {};
  CAMPAIGN_CONFIG_FIELDS.forEach((k) => {
    out[k] = campaign[k] === undefined ? null : campaign[k];
  });
  return out;
};

/** Escucha las campañas de saldo. Devuelve la función para dejar de escuchar. */
export const subscribeWalletCampaigns = (onData, onError) => {
  const { walletCampaignsRef } = firebase;
  return onValue(
    walletCampaignsRef,
    (snap) => {
      const data = snap.val() || {};
      onData(
        Object.keys(data)
          .map((id) => ({ ...data[id], id }))
          .sort((a, b) => (Number(b.createdAt) || 0) - (Number(a.createdAt) || 0))
      );
    },
    (err) => (onError ? onError(err) : onData([]))
  );
};

/** Solo el administrador principal. Al editar no toca los contadores que lleva el servidor. */
export const saveWalletCampaign = async (campaign) => {
  const { walletCampaignsRef, walletCampaignRef, auth } = firebase;
  const config = pickConfig(campaign);
  if (campaign.id) {
    await update(walletCampaignRef(campaign.id), config);
    return campaign.id;
  }
  const res = await push(walletCampaignsRef, {
    ...config,
    createdAt: Date.now(),
    createdBy: auth.currentUser ? auth.currentUser.uid : null,
  });
  return res.key;
};

export const setWalletCampaignActive = (id, active) => {
  const { walletCampaignRef } = firebase;
  return update(walletCampaignRef(id), { active: !!active });
};

export const deleteWalletCampaign = (id) => {
  const { walletCampaignRef } = firebase;
  return remove(walletCampaignRef(id));
};

export const fetchWalletCampaignGrants = async (id) => {
  const { walletCampaignGrantsRef } = firebase;
  const data = (await get(walletCampaignGrantsRef(id))).val() || {};
  return Object.keys(data)
    .map((uid) => ({ ...data[uid], uid }))
    .sort((a, b) => (Number(b.date) || 0) - (Number(a.date) || 0));
};
